import { styled } from '@mui/material/styles';
import { Box } from 'components/ui';

export const ContactAdminRoot = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  width: '100%',
}));
